export interface Character {
  id: number;
  name: string;
  race: string;
  class: string;
  vitality: number;
  intelligence: number;
  strength: number;
  dexterity: number;
  constitution: number;
  wisdom: number;
  level: number;
  experience: number;
  maxHP: number;
  currentHP: number;
  maxMP: number;
  currentMP: number;
  actionPoints: number;
  movementPoints: number;
  weaponSlot?: string;
  armorSlot?: string;
  accessorySlot?: string;
  talentPoints?: number; // From TalentPointBalance table
  createdAt: string;
  updatedAt: string;
}

export interface CreateCharacterRequest {
  name: string;
  race: string;
  class: string;
  vitality: number;
  intelligence: number;
  strength: number;
  dexterity: number;
  constitution: number;
  wisdom: number;
}

export interface UpdateCharacterRequest {
  name?: string;
  vitality?: number;
  intelligence?: number;
  strength?: number;
  dexterity?: number;
  constitution?: number;
  wisdom?: number;
  experience?: number;
  currentHP?: number;
  currentMP?: number;
  weaponSlot?: string;
  armorSlot?: string;
  accessorySlot?: string;
}

export const VALID_RACES = ['Human', 'Elf', 'Dwarf', 'Orc', 'Halfling'] as const;
export const VALID_CLASSES = ['Warrior', 'Mage', 'Ranger', 'Rogue', 'Cleric'] as const;

export type Race = typeof VALID_RACES[number];
export type CharacterClass = typeof VALID_CLASSES[number];